"use client";

import Link from "next/link";
import ButtonTextIcon from "../_ui/ButtonTextIcon";
import CustomButton from "../common/CustomButton";
import { ListingItems } from "../common/CommonComponents";
import Testimonialss from "./Home/ProviderTestimonials";
import Testimonials2 from "./Home/ProviderTestimonials";
import { AnimatedSection, getLastName } from "../../utils/helpers";
import Image from "next/image";
import { physicianCardioData,physicianNeuroData,physicianObsGynData,physicianOrthoPedicData,physicianRoboticData,SpecialTeam } from "../../data/surgicalAssistants";

export const AllPhysician = ({ title1, title2, listItem }) => {
  // ── helpers ──────────────────────────────────────────────────────────────
  const sortByLastName = (arr, getName) =>
    [...arr].sort((a, b) =>
      getLastName(getName(a)).localeCompare(getLastName(getName(b)))
    );

  // sorted lists
  const generalSurgeons = sortByLastName(
    SpecialTeam.filter((s) => s.specialtyType === "General Surgery"),
    (s) => s.surgeonTxt1
  );

  const cardioSurgeons = sortByLastName(
    physicianCardioData,
    (p) => p.provider_General_surgery_detail.mdName
  );

  const roboticSurgeons = sortByLastName(
    physicianRoboticData,
    (p) => p.provider_General_surgery_detail.mdName
  );

  const orthopedicSurgeons = sortByLastName(
    physicianOrthoPedicData,
    (p) => p.provider_General_surgery_detail.mdName
  );

  // physicianObsGynData[1] (Zishan Hirani) is intentionally excluded —
  // matches the original commented-out entry in this section.
  const obsGynSurgeons = sortByLastName(
    physicianObsGynData.filter((_, i) => i !== 1),
    (p) => p.provider_General_surgery_detail.mdName
  );

  const neuroSurgeons = sortByLastName(
    physicianNeuroData,
    (p) => p.provider_General_surgery_detail.mdName
  );

  return (
    <section class="specialists-section">
      <div class="specialists-container">
        <div class="specialist-box">
          <h2 class="l-h-1 color-blue f-w-300 font-barlow t-t-u">GENERAL SURGERY SPECIALISTS</h2>
          <div className="specialists-list">
            <ul>
              {generalSurgeons.slice(0, Math.ceil(generalSurgeons.length / 2)).map((s, i) => (
                <Link key={`gen1-${i}`} href={{ pathname: "/general-surgery-detailpage", query: { slug: s.surgeonTxt1 }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.surgeonTxt1}</li>
                </Link>
              ))}
            </ul>
            <ul>
              {generalSurgeons.slice(Math.ceil(generalSurgeons.length / 2)).map((s, i) => (
                <Link key={`gen2-${i}`} href={{ pathname: "/general-surgery-detailpage", query: { slug: s.surgeonTxt1 }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.surgeonTxt1}</li>
                </Link>
              ))}
            </ul>
          </div>
          <Link href="/general-surgery?specialty=General Surgery" passHref>
            <CustomButton
              title="VIEW ALL PHYSICIANS"
              className="f-w-400 font-robo f-18"
              style={{
                boxShadow: "0 10px 6px rgba(0, 0, 0, 0.2)",
                letterSpacing: 1,
              }}
            />
          </Link>
        </div>
        <div class="specialist-box">
          <h2 class="l-h-1 color-blue f-w-300 font-barlow t-t-u">CARDIO-THORACIC SURGERY SPECIALISTS</h2>
          <div className="specialists-list">
            <ul>
              {cardioSurgeons.slice(0, Math.ceil(cardioSurgeons.length / 2)).map((s, i) => (
                <Link key={`card1-${i}`} href={{ pathname: "/cardio-thoracic-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
            <ul>
              {cardioSurgeons.slice(Math.ceil(cardioSurgeons.length / 2)).map((s, i) => (
                <Link key={`card2-${i}`} href={{ pathname: "/cardio-thoracic-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
          </div>
          <Link href="/general-surgery?specialty=Cardio-Thoracic" passHref>
            <CustomButton
              title="VIEW ALL PHYSICIANS"
              className="f-w-400 font-robo f-18"
              style={{
                boxShadow: "0 10px 6px rgba(0, 0, 0, 0.2)",
                letterSpacing: 1,
              }}
            />
          </Link>
        </div>
      </div>
      <div class="specialists-container">
        <div class="specialist-box">
          <h2 class="l-h-1 color-blue f-w-300 font-barlow t-t-u">ROBOTIC SURGERY SPECIALISTS</h2>
          <div className="specialists-list">
            <ul>
              {roboticSurgeons.slice(0, Math.ceil(roboticSurgeons.length / 2)).map((s, i) => (
                <Link key={`rob1-${i}`} href={{ pathname: "/robotic-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
            <ul>
              {roboticSurgeons.slice(Math.ceil(roboticSurgeons.length / 2)).map((s, i) => (
                <Link key={`rob2-${i}`} href={{ pathname: "/robotic-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
          </div>
          <Link href="/general-surgery?specialty=Robotic" passHref>
            <CustomButton
              title="VIEW ALL PHYSICIANS"
              className="f-w-400 font-robo f-18"
              style={{
                boxShadow: "0 10px 6px rgba(0, 0, 0, 0.2)",
                letterSpacing: 1,
              }}
            />
          </Link>
        </div>
        <div class="specialist-box">
          <h2 class="l-h-1 color-blue f-w-300 font-barlow t-t-u">ORTHOPEDIC SURGERY SPECIALISTS</h2>
          <div className="specialists-list">
            <ul>
              {orthopedicSurgeons.slice(0, Math.ceil(orthopedicSurgeons.length / 2)).map((s, i) => (
                <Link key={`ortho1-${i}`} href={{ pathname: "/orthopedic-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
            <ul>
              {orthopedicSurgeons.slice(Math.ceil(orthopedicSurgeons.length / 2)).map((s, i) => (
                <Link key={`ortho2-${i}`} href={{ pathname: "/orthopedic-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20">{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
          </div>
          <Link href="/general-surgery?specialty=Orthopedic" passHref>
            <CustomButton
              title="VIEW ALL PHYSICIANS"
              className="f-w-400 font-robo f-18"
              style={{
                boxShadow: "0 10px 6px rgba(0, 0, 0, 0.2)",
                letterSpacing: 1,
              }}
            />
          </Link>
        </div>
      </div>
      <div class="specialists-container">
        <div class="specialist-box">
          <h2 class="l-h-1 color-blue f-w-300 font-barlow t-t-u">Obstetrics & Gynecology Surgery Specialists</h2>
          <div className="specialists-list">
            <ul>
              {obsGynSurgeons.slice(0, Math.ceil(obsGynSurgeons.length / 2)).map((s, i) => (
                <Link key={`obs1-${i}`} href={{ pathname: "/obs-gyn-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20" style={{ whiteSpace: "nowrap" }}>{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
            <ul>
              {obsGynSurgeons.slice(Math.ceil(obsGynSurgeons.length / 2)).map((s, i) => (
                <Link key={`obs2-${i}`} href={{ pathname: "/obs-gyn-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20" style={{ whiteSpace: "nowrap" }}>{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
          </div>
          <Link href="/general-surgery?specialty=Obs-Gyn" passHref>
            <CustomButton
              title="VIEW ALL PHYSICIANS"
              className="f-w-400 font-robo f-18"
              style={{
                boxShadow: "0 10px 6px rgba(0, 0, 0, 0.2)",
                letterSpacing: 1,
              }}
            />
          </Link>
        </div>
        <div class="specialist-box">
          <h2 class="l-h-1 color-blue f-w-300 font-barlow t-t-u">
            NEURO-SPINAL <br /> SURGERY SPECIALISTS
          </h2>
          <div className="specialists-list">
            <ul>
              {neuroSurgeons.slice(0, Math.ceil(neuroSurgeons.length / 2)).map((s, i) => (
                <Link key={`neuro1-${i}`} href={{ pathname: "/neuro-spinal-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20" style={{ whiteSpace: "nowrap" }}>{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
            <ul>
              {neuroSurgeons.slice(Math.ceil(neuroSurgeons.length / 2)).map((s, i) => (
                <Link key={`neuro2-${i}`} href={{ pathname: "/neuro-spinal-surgery-detailpage", query: { slug: s.provider_General_surgery_detail.mdName }, hash: 'surgeonD' }}>
                  <li className="font-montserrat p-16 f-w-400 mar-b-20" style={{ whiteSpace: "nowrap" }}>{s.provider_General_surgery_detail.mdName}</li>
                </Link>
              ))}
            </ul>
          </div>
          <Link href="/general-surgery?specialty=Neuro-Spinal" passHref>
            <CustomButton
              title="VIEW ALL PHYSICIANS"
              className="f-w-400 font-robo f-18"
              style={{
                boxShadow: "0 10px 6px rgba(0, 0, 0, 0.2)",
                letterSpacing: 1,
              }}
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export const ProviderTeam = ({ title, data, split = true, image }) => {
  return (
    <section id="provider-page">
      <div className="team">
        <div className="container">
          <div className="flex provider-box" style={{ gap: "20px", justifyContent: "space-between", alignItems: "center" }}>
            {/* outer-left */}

            <div className=" flex  provider-top ">
              <div className=" txt-box">
                <h1 className="l-h-1 color-blue f-w-300 font-barlow col-7-10">{title}</h1>
                <div className="row ">
                  <div className=" flex con list-items">
                    {split ? (
                      <>
                        {/* First 5 items */}
                        <ListingItems data={data} sliceStart={0} sliceEnd={5} />
                        {/* Remaining items */}
                        <ListingItems data={data} sliceStart={5} />
                      </>
                    ) : (
                      // Show all items if split is false
                      <ListingItems data={data} />
                    )}
                  </div>
                </div>
              </div>
              <div className="btn">
                <Link href="/careers">
                  <ButtonTextIcon
                    icon={
                      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.8869 9.54111L10.1397 13.0356C9.92875 13.461 9.31703 13.447 9.12367 13.0146L7.12328 8.57432L6.06859 11.095H2.76039L9.1764 17.6517C9.42601 17.9083 9.83031 17.9083 10.0799 17.6517L16.4994 11.095H12.6639L11.8869 9.54111ZM17.2834 3.56807L17.1991 3.48018C15.3885 1.63096 12.4248 1.63096 10.6108 3.48018L9.62992 4.48564L8.64906 3.48369C6.83851 1.63096 3.87132 1.63096 2.06078 3.48369L1.9764 3.56807C0.264292 5.31885 0.190464 8.10674 1.71976 9.97002H5.31976L6.58187 6.93955C6.77171 6.48604 7.41156 6.47549 7.61546 6.92549L9.66156 11.4712L11.3842 8.02939C11.5916 7.61455 12.1823 7.61455 12.3897 8.02939L13.36 9.97002H17.5401C19.0694 8.10674 18.9955 5.31885 17.2834 3.56807Z"
                          fill="black"
                        />
                      </svg>
                    }
                    iconPosition="start"
                    title="JOIN OUR TEAM"
                  />
                </Link>
              </div>
            </div>
            {/* outer-right */}
            <div className="flex image-box">
              <AnimatedSection animation="slideInRight" speed="fast">
                <div className="img">
                  {/* <img className="b-r-10" src={image} alt="Provider-team" /> */}
                  <img
                    className="b-r-10"
                    src={image}
                    alt="Provider-team"
                    width={500} // set your preferred width
                    height={300} // set your preferred height
                  />
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const SupportStaff = ({ image, heading, title, sub, content, content2, btn = false, data, sliceEnd, isHide }) => {
  return (
    <section id="provider-page">
      <div className="support-staff">
        <div className="container">
          <div className="flex row " style={{ alignItems: "center" }}>
            <div className="flex image-box">
              <div className="img">
                <AnimatedSection animation="bounceIn">
                  <img className="b-10" src={image ? image : "/images/providers/staff-support-new.png"} alt="staff-support" />
                  {/* <Image
                    className="b-r-10"
                    src={image ? image : "/images/providers/staff-support.webp"}
                    alt="staff-support"
                    width={500} // set your preferred width
                    height={300} // set your preferred height
                  /> */}
                </AnimatedSection>
              </div>
            </div>

            <div className="flex-1  sup-content  ">
              <div className="">
                <h6 className="f-w-400 font-montserrat">{heading}</h6>
                <br />
                <h2 className="l-h-1 color-blue f-w-300 font-barlow t-t-u">{title}</h2>
                <br />
                <p className="p-18 f-w-400 font-nunito-sans ">{content2}</p>
                <br />
                <p className="p-18 f-w-400 font-nunito-sans ">{content}</p>

                {isHide && (
                  <>
                    <h5 className="font-mont f-w-600">{sub}</h5>

                    <div className="content flex">
                      <ListingItems data={data} sliceStart={0} sliceEnd={sliceEnd} />

                      <ListingItems data={data} sliceStart={sliceEnd} />
                    </div>
                  </>
                )}

                {btn ? (
                  <div className="btn">
                    <Link href="/current-job-openings">
                      {/* <Link href="/careers"> */}
                      <ButtonTextIcon
                        icon={
                          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M11.8869 9.54111L10.1397 13.0356C9.92875 13.461 9.31703 13.447 9.12367 13.0146L7.12328 8.57432L6.06859 11.095H2.76039L9.1764 17.6517C9.42601 17.9083 9.83031 17.9083 10.0799 17.6517L16.4994 11.095H12.6639L11.8869 9.54111ZM17.2834 3.56807L17.1991 3.48018C15.3885 1.63096 12.4248 1.63096 10.6108 3.48018L9.62992 4.48564L8.64906 3.48369C6.83851 1.63096 3.87132 1.63096 2.06078 3.48369L1.9764 3.56807C0.264292 5.31885 0.190464 8.10674 1.71976 9.97002H5.31976L6.58187 6.93955C6.77171 6.48604 7.41156 6.47549 7.61546 6.92549L9.66156 11.4712L11.3842 8.02939C11.5916 7.61455 12.1823 7.61455 12.3897 8.02939L13.36 9.97002H17.5401C19.0694 8.10674 18.9955 5.31885 17.2834 3.56807Z"
                              fill="black"
                            />
                          </svg>
                        }
                        iconPosition="start"
                        title="JOIN OUR TEAM"
                      />
                    </Link>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const MedicEducation = ({ title, content, image, data, isHide }) => {
  return (
    <section id="provider-page" className="MedicEducation">
      <div className="team">
        <div className="container">
          <div className="flex provider-box" style={{ gap: "25px", justifyContent: "space-between", alignItems: "center" }}>
            {/* outer-left */}

            <div className=" flex  provider-top  " style={{ flexDirection: "column" }}>
              <div className=" txt-box">
                <h1 className="l-h-1 color-blue f-w-300 font-barlow ">{title}</h1>
                <br />
                <p className="p-18 f-w-400 font-nunito-sans">{content}</p>
                <div className="row ">
                  <div className=" flex con">
                    {/* ==left== */}
                    <ListingItems data={data} sliceStart={0} sliceEnd={4} />

                    {/* ==right== */}
                    {/* <ListingItems data={data} sliceStart={3} /> */}
                  </div>
                </div>
              </div>

              {isHide && (
                <div className="btn">
                  <Link href="/current-job-openings">
                    {/* <Link href="/careers"> */}
                    <ButtonTextIcon
                      icon={
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.8869 9.54111L10.1397 13.0356C9.92875 13.461 9.31703 13.447 9.12367 13.0146L7.12328 8.57432L6.06859 11.095H2.76039L9.1764 17.6517C9.42601 17.9083 9.83031 17.9083 10.0799 17.6517L16.4994 11.095H12.6639L11.8869 9.54111ZM17.2834 3.56807L17.1991 3.48018C15.3885 1.63096 12.4248 1.63096 10.6108 3.48018L9.62992 4.48564L8.64906 3.48369C6.83851 1.63096 3.87132 1.63096 2.06078 3.48369L1.9764 3.56807C0.264292 5.31885 0.190464 8.10674 1.71976 9.97002H5.31976L6.58187 6.93955C6.77171 6.48604 7.41156 6.47549 7.61546 6.92549L9.66156 11.4712L11.3842 8.02939C11.5916 7.61455 12.1823 7.61455 12.3897 8.02939L13.36 9.97002H17.5401C19.0694 8.10674 18.9955 5.31885 17.2834 3.56807Z"
                            fill="black"
                          />
                        </svg>
                      }
                      iconPosition="start"
                      title="JOIN OUR TEAM"
                    />
                  </Link>
                </div>
              )}
            </div>

            {/* outer-right */}
            <div className="flex image-box">
              <AnimatedSection animation="slideInRight" speed="700ms">
                <div className=" img ">
                  <img className="b-10" src={image} alt={title} />
                  {/* <Image
                    className="b-r-10"
                    src={image}
                    alt={title}
                    width={500} // set your preferred width
                    height={300} // set your preferred height
                  /> */}
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const ProviderTestimonial = () => {
  return (
    <section id="provider-page">
      <div
        className="testimonials pos-rel cover-img"
        style={{
          backgroundImage: `url(/images/providers/background.webp)`,
        }}
      >
        <div className="container">
          <div className=" flex testimonial-box">
            <div className="mar-l-a slider-content">
              <div className=" box ">
                <Testimonials2 />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
